<template>
    <div class="TestKitList">
        <div class="form">
            <el-form ref="tableApple" :inline="true" label-width="100px" :model="formApple" @submit.native.prevent>
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="姓名" prop="name">
                            <el-input v-model="formApple.patientName" clearable placeholder="请输入姓名"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="手机号" prop="phoneNo">
                            <el-input v-model="formApple.iphoneNo" clearable placeholder="请输入手机号"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="身份证号" prop="idCardNo">
                            <el-input v-model="formApple.idCardNo" clearable placeholder="请输入身份证号"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="管理医生" prop="inviter">
                            <el-select v-model="formApple.doctor" clearable placeholder="请选择领取地点">
                                <el-option v-for="item in findDoctorList" :key="item.id" :label="item.docName"
                                    :value="item.docName">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item class="TestKitList-form-button">
                            <el-button @click="onSubmit" native-type="submit" type="primary">查询</el-button>
                            <el-button @click="Reset">重置</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>

        <div class="list">
            <el-table :data="tableApple" v-loading="tableLoad" element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
                style="width: 100%">
                <el-table-column prop="patientName" align="center" label="姓名">
                    <template slot-scope="scope">
                        <span class="TestKitList-list-blue" @click="detail(scope.row)">{{scope.row.patientName}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="iphoneNo" align="center" label="手机号">
                </el-table-column>
                <el-table-column width="200" prop="idcardNo" align="center" label="身份证号">
                </el-table-column>
                <el-table-column prop="doctorName" align="center" label="管理医生">
                </el-table-column>
                <el-table-column prop="writeTime" align="center" label="填表日期" />
                <el-table-column width="200" prop="detectResult" align="center" label="知情同意书">
                    <template slot-scope="scope">
                        <a style="color: #66B1FF;" :href="scope.row.informedConsentFormUrl" target="_blank">查看</a>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChangeApple" @current-change="handleCurrentChangeApple"
                :current-page="formApple.pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="formApple.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="totalApple">
            </el-pagination>

        </div>
    </div>
</template>

<script>
export default {

    name: 'ColorectalScreening',
    data() {
        return {
            findDoctorList: [],
            tableApple: [],
            totalApple: 0,
            formApple: {
                patientName: "",
                iphoneNo: "",
                idCardNo: "",
                doctor: "",
                pageNum: 1,
                pageSize: 10
            },
            table: [],
            tableLoad: false,
        }
    },
    computed: {
        routerName() {
            return this.$route.name
        },
    },
    filters: {
        getDict(value, list) {
            return (list.find((v) => v.value == value) || {}).label || value
        },
    },
    created() {
        this.findDoctor()
        this.getListApple()
    },
    methods: {
        /* 查看pdf */
        visitPdf(row){
            console.log('row++++', row)
        },

        findDoctor() {
            this.$get('hh/polypInfo/findDoctorList').then((res) => {
                this.findDoctorList = res.data
            }).catch(err => {
                console.log('err: ', err, "API: hh/polypInfo/findDoctorList")
            })
        },
        onSubmit() {
            this.formApple.pageNum = 1;
            this.$nextTick(() => {
                this.getListApple()
            })
        },
        Reset() {
            this.$refs['tableApple'].resetFields()
            this.formApple = {
                patientName: "",
                iphoneNo: "",
                idCardNo: "",
                doctor: "",
                pageNum: 1,
                pageSize: 10
            }

            this.$nextTick(() => {
                this.getListApple()

            })
        },
        getListApple() {
            this.$post('hh/polypInfo/findZslyQuestionnaireList', this.formApple).then((res) => {
                this.tableApple = res.data.list
                this.totalApple = res.data.total
            }).catch(err => {
                console.log('err:', err, 'api: hh/polypInfo/findZslyQuestionnaireList')
            })
        },


        handleCurrentChangeApple(e) {
            this.formApple.pageNum = e;
            this.$nextTick(() => {
                this.getListApple()
            })
        },
        handleSizeChangeApple(e) {
            this.formApple.pageSize = e;
            this.$nextTick(() => {
                this.getListApple()
            })
        },
        dataPDF(e) {
            let obj = {
                reagentId: e.reagentId,
            }
            return obj
        },

        detail(row) {
            this.$router.push({
                path: '/' + this.routerName + 'Detail',
                query: {
                    reagentId: row.patientOpenid,
                },
            })
        },
    },
}
</script>

<style lang="scss" scoped>
@import '../../style/TestKit/TestKitList';
</style>
